import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { SearchInput } from '../../components/ui/Input';
import { Building2, Mail, Calendar, MoreHorizontal, UserPlus, X } from 'lucide-react';
const users = [{
  id: 1,
  name: 'John Doe',
  email: 'john@excelhomes.com',
  role: 'Builder Admin',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  lastActive: '2 hours ago',
  joinedDate: '2023-06-15'
}, {
  id: 2,
  name: 'Sarah Johnson',
  email: 'sarah@excelhomes.com',
  role: 'Builder Employee',
  builder: 'Excel Homes',
  builderId: 1,
  status: 'Active',
  lastActive: '1 day ago',
  joinedDate: '2023-08-20'
}, {
  id: 3,
  name: 'Michael Chen',
  email: 'michael@schellbrothers.com',
  role: 'Builder Admin',
  builder: 'Schell Brothers',
  builderId: 2,
  status: 'Active',
  lastActive: '30 mins ago',
  joinedDate: '2023-03-22'
}, {
  id: 4,
  name: 'Emily Rodriguez',
  email: 'emily@mattamyhomes.com',
  role: 'Builder Admin',
  builder: 'Mattamy Homes',
  builderId: 3,
  status: 'Active',
  lastActive: '5 hours ago',
  joinedDate: '2022-11-10'
}, {
  id: 5,
  name: 'David Park',
  email: 'david@landmarkhomes.com',
  role: 'Builder Employee',
  builder: 'Landmark Homes',
  builderId: 4,
  status: 'Active',
  lastActive: '2 days ago',
  joinedDate: '2024-01-10'
}, {
  id: 6,
  name: 'Lisa Thompson',
  email: 'lisa@starwardhomes.com',
  role: 'Builder Admin',
  builder: 'Starward Homes',
  builderId: 5,
  status: 'Active',
  lastActive: '1 hour ago',
  joinedDate: '2023-09-08'
}, {
  id: 7,
  name: 'Rohit Patel',
  email: 'rohit@rohit.com',
  role: 'Builder Admin',
  builder: 'Rohit',
  builderId: 6,
  status: 'Inactive',
  lastActive: '2 weeks ago',
  joinedDate: '2023-11-30'
}];
const buildersList = [{
  id: 1,
  name: 'Excel Homes'
}, {
  id: 2,
  name: 'Schell Brothers'
}, {
  id: 3,
  name: 'Mattamy Homes'
}, {
  id: 4,
  name: 'Landmark Homes'
}, {
  id: 5,
  name: 'Starward Homes'
}, {
  id: 6,
  name: 'Rohit'
}];
const builders = ['All Builders', 'Excel Homes', 'Schell Brothers', 'Mattamy Homes', 'Landmark Homes', 'Starward Homes', 'Rohit'];
export function UsersPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBuilder, setSelectedBuilder] = useState('All Builders');
  const [roleFilter, setRoleFilter] = useState('All Roles');
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    builderId: '',
    role: ''
  });
  const filteredUsers = users.filter(user => {
    const matchesSearch = user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesBuilder = selectedBuilder === 'All Builders' || user.builder === selectedBuilder;
    const matchesRole = roleFilter === 'All Roles' || user.role === roleFilter;
    return matchesSearch && matchesBuilder && matchesRole;
  });
  // ESC key handler
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && showAddUserModal) {
        setShowAddUserModal(false);
        setNewUser({
          name: '',
          email: '',
          builderId: '',
          role: ''
        });
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [showAddUserModal]);
  const handleAddUser = () => {
    console.log('Adding new user:', newUser);
    setShowAddUserModal(false);
    setNewUser({
      name: '',
      email: '',
      builderId: '',
      role: ''
    });
  };
  return <>
      <div className="space-y-6 max-w-7xl mx-auto" data-id="element-3045">
        <div className="flex items-center justify-between" data-id="element-3046">
          <div data-id="element-3047">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-3048">Users</h1>
            <p className="text-slate-500" data-id="element-3049">Manage users across all builders</p>
          </div>
          <Button leftIcon={<UserPlus className="h-4 w-4" data-id="element-3051" />} onClick={() => setShowAddUserModal(true)} data-id="element-3050">
            Add User
          </Button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-3052">
          <Card data-id="element-3053">
            <div className="p-6" data-id="element-3054">
              <p className="text-sm text-slate-500" data-id="element-3055">Total Users</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-3056">
                {users.length}
              </p>
            </div>
          </Card>
          <Card data-id="element-3057">
            <div className="p-6" data-id="element-3058">
              <p className="text-sm text-slate-500" data-id="element-3059">Active Users</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-3060">
                {users.filter(u => u.status === 'Active').length}
              </p>
            </div>
          </Card>
          <Card data-id="element-3061">
            <div className="p-6" data-id="element-3062">
              <p className="text-sm text-slate-500" data-id="element-3063">Builder Admins</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-3064">
                {users.filter(u => u.role === 'Builder Admin').length}
              </p>
            </div>
          </Card>
          <Card data-id="element-3065">
            <div className="p-6" data-id="element-3066">
              <p className="text-sm text-slate-500" data-id="element-3067">Employees</p>
              <p className="text-2xl font-bold text-slate-900 mt-1" data-id="element-3068">
                {users.filter(u => u.role === 'Builder Employee').length}
              </p>
            </div>
          </Card>
        </div>

        <Card noPadding data-id="element-3069">
          <div className="p-4 border-b border-slate-200 bg-slate-50 rounded-t-xl space-y-4" data-id="element-3070">
            <div className="flex items-center justify-between gap-4" data-id="element-3071">
              <SearchInput className="max-w-sm bg-white" placeholder="Search by name or email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-3072" />
              <div className="flex gap-2" data-id="element-3073">
                <Button variant="outline" size="sm" data-id="element-3074">
                  Export
                </Button>
              </div>
            </div>

            {/* Filters */}
            <div className="flex gap-3" data-id="element-3075">
              <select value={selectedBuilder} onChange={e => setSelectedBuilder(e.target.value)} className="px-3 py-1.5 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-3076">
                {builders.map(builder => <option key={builder} value={builder} data-id="element-3077">
                    {builder}
                  </option>)}
              </select>
              <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} className="px-3 py-1.5 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-3078">
                <option value="All Roles" data-id="element-3079">All Roles</option>
                <option value="Builder Admin" data-id="element-3080">Builder Admin</option>
                <option value="Builder Employee" data-id="element-3081">Builder Employee</option>
              </select>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-3082">
            <table className="w-full text-left text-sm" data-id="element-3083">
              <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-3084">
                <tr data-id="element-3085">
                  <th className="px-6 py-4" data-id="element-3086">User</th>
                  <th className="px-6 py-4" data-id="element-3087">Builder</th>
                  <th className="px-6 py-4" data-id="element-3088">Role</th>
                  <th className="px-6 py-4" data-id="element-3089">Status</th>
                  <th className="px-6 py-4" data-id="element-3090">Last Active</th>
                  <th className="px-6 py-4" data-id="element-3091">Joined</th>
                  <th className="px-6 py-4 text-right" data-id="element-3092">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-3093">
                {filteredUsers.length === 0 ? <tr data-id="element-3094">
                    <td colSpan={7} className="px-6 py-12 text-center text-slate-500" data-id="element-3095">
                      No users found matching your filters
                    </td>
                  </tr> : filteredUsers.map(user => <tr key={user.id} className="hover:bg-slate-50 transition-colors" data-id="element-3096">
                      <td className="px-6 py-4" data-id="element-3097">
                        <div className="flex items-center gap-3" data-id="element-3098">
                          <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 font-semibold text-sm" data-id="element-3099">
                            {user.name.split(' ').map(n => n[0]).join('')}
                          </div>
                          <div data-id="element-3100">
                            <p className="font-medium text-slate-900" data-id="element-3101">
                              {user.name}
                            </p>
                            <p className="text-xs text-slate-500 flex items-center gap-1" data-id="element-3102">
                              <Mail className="h-3 w-3" data-id="element-3103" />
                              {user.email}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-3104">
                        <div className="flex items-center gap-2" data-id="element-3105">
                          <Building2 className="h-4 w-4 text-slate-400" data-id="element-3106" />
                          <span className="text-slate-600" data-id="element-3107">{user.builder}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-3108">
                        <Badge variant="neutral" data-id="element-3109">{user.role}</Badge>
                      </td>
                      <td className="px-6 py-4" data-id="element-3110">
                        <Badge variant={user.status === 'Active' ? 'success' : 'neutral'} data-id="element-3111">
                          {user.status}
                        </Badge>
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-3112">
                        {user.lastActive}
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-3113">
                        <div className="flex items-center gap-1" data-id="element-3114">
                          <Calendar className="h-3 w-3 text-slate-400" data-id="element-3115" />
                          {new Date(user.joinedDate).toLocaleDateString()}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-right" data-id="element-3116">
                        <div className="flex items-center justify-end gap-2" data-id="element-3117">
                          <Button variant="ghost" size="sm" data-id="element-3118">
                            Edit
                          </Button>
                          <Button variant="ghost" size="sm" data-id="element-3119">
                            <MoreHorizontal className="h-4 w-4" data-id="element-3120" />
                          </Button>
                        </div>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Add User Modal */}
      {showAddUserModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-3121">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-3122">
            <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-3123">
              <div data-id="element-3124">
                <h2 className="text-xl font-bold text-slate-900" data-id="element-3125">
                  Add New User
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-3126">
                  Create a new user account for a builder
                </p>
              </div>
              <button onClick={() => setShowAddUserModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-3127">
                <X className="h-5 w-5" data-id="element-3128" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-3129">
              <div data-id="element-3130">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-3131">
                  Full Name
                </label>
                <input type="text" value={newUser.name} onChange={e => setNewUser({
              ...newUser,
              name: e.target.value
            })} placeholder="e.g., John Smith" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" autoFocus data-id="element-3132" />
              </div>
              <div data-id="element-3133">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-3134">
                  Email Address
                </label>
                <input type="email" value={newUser.email} onChange={e => setNewUser({
              ...newUser,
              email: e.target.value
            })} placeholder="e.g., john@excelhomes.com" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:ring-primary-500 focus:border-primary-500" data-id="element-3135" />
              </div>
              <div data-id="element-3136">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-3137">
                  Builder Company
                </label>
                <select value={newUser.builderId} onChange={e => setNewUser({
              ...newUser,
              builderId: e.target.value
            })} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-3138">
                  <option value="" data-id="element-3139">Select a builder...</option>
                  {buildersList.map(builder => <option key={builder.id} value={builder.id} data-id="element-3140">
                      {builder.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-3141">
                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-3142">
                  Role
                </label>
                <select value={newUser.role} onChange={e => setNewUser({
              ...newUser,
              role: e.target.value
            })} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-3143">
                  <option value="" data-id="element-3144">Select a role...</option>
                  <option value="Builder Admin" data-id="element-3145">Builder Admin</option>
                  <option value="Builder Employee" data-id="element-3146">Builder Employee</option>
                </select>
              </div>
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-3147">
                <p className="text-xs text-blue-800" data-id="element-3148">
                  An invitation email will be sent to the user with login
                  instructions.
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-3149">
              <Button variant="outline" onClick={() => setShowAddUserModal(false)} data-id="element-3150">
                Cancel
              </Button>
              <Button onClick={handleAddUser} disabled={!newUser.name || !newUser.email || !newUser.builderId || !newUser.role} leftIcon={<UserPlus className="h-4 w-4" data-id="element-3152" />} data-id="element-3151">
                Add User
              </Button>
            </div>
          </div>
        </div>}
    </>;
}